import DataList from "./DataList";
import Datum from "./Datum";

export { Datum };

export default DataList;
